import {Header} from './components/header/header';
import {Nav} from './components/nav/nav';
import {About} from './components/about/about';
import Home from './components/home/home';
import {Contact} from './components/contact/contact';
import {Testimonial} from './components/testemonal/testemonal';
import Experience from './components/experience/Experience';
import { Services } from './components/services/Services';
import {Imgup} from './components/img/imgup';
import { Portifolio } from './components/portifolio/portifolio';
import { Route, Routes } from 'react-router-dom';
// import surveypage from './components/portifolio/demopages/survey2.html';
// import tendermspage from './components/portifolio/demopages/T/tenderms.html';
// import examination from './components/portifolio/demopages/examination/examination';
// import examination from './components/portifolio/demopages/examination.html';
import {Footer}  from './components/footer/footer'
import PageTitle  from './components/pageTitle/pagetitle'
import Logo from './components/testemonal/trial'
// import Scraped from './components/testemonal/try' 

function App() {
  return (

    
    <div>
    <PageTitle title="Mehari" />
       {/* <Portifolio /> */}
      
       <Nav />
      <Routes>
        <Route path="/" element={<>  
            <Header />
            <Portifolio/>
            {/* <About /> */}
            <Experience />
            <Services />
            <Testimonial />
            
            <Contact />
       </>}/>

        {/* <Route path="/about" element={<><Experience /> <Nav /> </>} /> */}
        
        {/* <Route path="/survey" element={
  <div dangerouslySetInnerHTML={{__html: surveypage}}></div> 
         } />

        <Route path="/survey" element={
          <div dangerouslySetInnerHTML={{__html: surveypage}}></div> 
                } />

        <Route path="/examination" element={
          <div dangerouslySetInnerHTML={{__html: examination}}></div> 
                } /> */}
      </Routes>
      <Footer/>
      {/* <Logo /> */}
    </div>
  );
}



export default App;
